function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconNew = function SvgIconNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4Zm-1-5a10 10 0 1 0 10 10A10.029 10.029 0 0 0 12 2Zm0 18a8 8 0 1 1 8-8 8.024 8.024 0 0 1-8 8Z",
    style: {
      fill: "#0a1343"
    },
    transform: "translate(-2 -2)"
  }));
};
export default SvgIconNew;